<template>
  <div :class="cssTheme" class="k-list-participants">
    <div class="km-scroll light-mode light-mode-bg-ff">
      <div class="km-flex-list">
        <div
          v-for="participant in participants"
          class="k-row k-border-bottom"
          :key="participant.id"
        >
          <div
            :class="getEditableClass(participant)"
            class="col-6 align-self-center"
            @click="startEditParticipant(participant)"
          >
            <render-participant
              :isOwner="isOwner"
              :tooltip="getEditableTooltip(participant)"
              :isEmailVisible="isEmailVisible(participant)"
              :isEditable="isEditable(participant)"
              :isCurrentUser="participant.isCurrentUser"
              :participant="participant"
              ref="participantNotification1"
            />
          </div>
          <div
            @click="editParticipantChoices(participant, $event)"
            :class="getEditableClass(participant)"
            class="col-6 justify-content-center k-border-left py-1"
          >
            <div v-if="isAnswered(participant)" class="event-participant pl-2">
              <div class="k-row text-size-24">
                <div class="d-block">
                  <div v-if="participant.choice < 0" class="mr-2">
                    <font-awesome-icon :icon="['fal', 'square']" />
                  </div>
                  <div v-else class="row mr-2">
                    <div
                      class="d-flex col justify-content-center align-items-center"
                    >
                      <div
                        v-if="participant.choice >= 1"
                        class="d-flex k-checked"
                      >
                        <font-awesome-icon
                          class="align-self-center"
                          :icon="['fas', 'check']"
                        />
                      </div>
                      <div v-else class="d-flex">
                        <font-awesome-icon
                          class="align-self-center"
                          :icon="['fas', 'times']"
                        />
                      </div>
                    </div>
                    <div
                      v-if="participant.choice > 1"
                      class="col k-checked align-items-stretch"
                    >
                      <div 
                      v-if="poll.options.limitedVotesPerEvent"
                      class="row">+ {{ participant.guests }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="k-row text-size-12">
                {{ participant.comment }}
              </div>
            </div>
            <div v-else class="text-size-14 align-self-start p-1">
              <div 
              :class="cssProvideAnswer"
              class="text-center"
              v-if="isEditable(participant)" v-html="pleaseAnswer">
              </div>
              <div v-else>
                <font-awesome-icon
                  class="text-size-18"
                  :icon="['fas', 'question']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalEventChoice ref="dlgEditEventChoice" @update="updateNotification" />

    <ModalParticipant
      ref="newParticipantModal"
      :user="user"
      :invitation="invitation"
      :edit-mode="modalEditMode"
      :edit-participant="editParticipant"
      @save="onSaveModal"
      @cancel="stopEditParticipant"
    >
    </ModalParticipant>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { themeMixin } from '../mixins/ThemeMixins';
import RenderParticipant from './RenderParticipant.vue';
import ModalEventChoice from '@/components/UI/ModalEventChoice';
import ModalParticipant from '@/components/UI/ModalParticipant';
import { renderMixin } from '../mixins/RenderMixins';
import { eventMixin } from '../mixins/EventMixins';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import { answerMixin } from '../mixins/AnswerMixins.js';

export default {
  name: 'RendererMobileEventParticipants',

  data() {
    return {
      curParticipant: 0,
    };
  },
  mixins: [themeMixin, renderMixin, eventMixin, modalParticipantMixins, answerMixin],
  components: {
    RenderParticipant,
    ModalEventChoice,
    ModalParticipant,
  },

  methods: {
    getOpenInvitation() {
      if (this.curInvitation && !this.curInvitation.participant_id) {
        return this.curInvitation.id;
      }
      return null;
    },
    updateNotification(participant) {
      this.onUpdate(participant).then(() => {
        let found = false;
        for(let i =0; i < this.poll.participants.length; i++) {
          if(this.poll.participants[i].isCurrentUser == true && this.poll.participants[i].user && this.poll.participants[i].user.id == this.ownerId) {
            found = true;
            this.$refs['participantNotification1'][0].compareChoices();
            break;
          }
        }
        if(found == false) {
          this.$refs['participantNotification1'][this.$refs['participantNotification1'].length - 1].compareChoices();
        } 
      });
    },

   getClassBasedOnChoice() {
      this.$refs['participantNotification1'][this.$refs['participantNotification1'].length - 1].compareChoices();
    },

  },
  computed: {
    ...mapState({
      curInvitation: (state) => state.curInvitation,
      poll: (state) => state.poll.poll,
      userId: (state) => state.Login.userId,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
    }),

    ...mapGetters(['isOwner', 'user']),

    // participants() {
    //   console.log('participants: ', this.poll.participants);
    //   let participants = this.poll.participants;
    //   return participants;
    // },

    participantCount() {
      return this.participants.length;
    },

    participant() {
      return this.participants[this.curParticipant];
    },
    participantName() {
      return this.participants[this.curParticipant].name;
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/style.scss';

.k-event-participant {
  display: flex;
}

.col-6 {
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  padding-right: 5px;
  align-items: stretch;
}

.k-guests {
  margin-top: 1px;
}

.event-status-number {
  line-height: 26px;
  font-size: 20px;
}

.event-status-label {
  line-height: 26px;
  font-size: 16px;
}

.fix-item {
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
